import { ColumnDef } from '@benzinga/table';
import { GovernmentTrade } from '@benzinga/gov-trades';
import dayjs from 'dayjs';

import { AmountBags } from './AmountBags';
import { ChamberBadge } from './memberBadges';
import { MemberNameLink, SecurityStackCell, TableLink, TxnSide } from './TableCells';

export interface GovernmentTradeRow extends GovernmentTrade {
  company_name: string;
  logo?: string;
  ticker: string;
}

const formatTransaction = (value: string) => {
  if (!value) return '';
  const isPartial = value.includes('(Partial)');
  const type = value.split(' ')[0];
  return (type === 'P' ? 'Purchase' : 'Sale') + (isPartial ? ' (Partial)' : '');
};

export const AllTradesColumnsDef = [
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => {
      const { company_name, logo, security, ticker } = data;
      return <SecurityStackCell logo={logo} name={company_name ?? security?.name} ticker={ticker} />;
    },
    field: 'security.name',
    headerName: 'Name',
    sortEnabled: false,
    valueGetter: ({ data }) => data?.security?.name ?? '',
    width: 200,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <AmountBags amount={data.amount} transactionType={data.transaction_type} />,
    field: 'amount',
    headerName: 'Amount',
    sortEnabled: false,
    width: 140,
  },
  {
    cellClass: 'security-cell type',
    field: 'security',
    headerName: 'Type',
    sortEnabled: false,
    valueFormatter: ({ value }) =>
      value?.type ? value.type.charAt(0).toUpperCase() + value.type.slice(1).toLowerCase() : '',
    width: 90,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <TxnSide type={data.transaction_type}>{formatTransaction(data.transaction_type)}</TxnSide>,
    field: 'transaction_type',
    headerName: 'Transaction',
    sortEnabled: false,
    width: 130,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <MemberNameLink name={data?.filer_info?.display_name} />,
    field: 'filer_info.display_name',
    headerName: 'Member',
    sortEnabled: false,
    valueGetter: ({ data }) => data?.filer_info?.display_name ?? '',
    width: 150,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => (
      <TableLink external href={data.disclosure_url}>
        {dayjs(data.report_date).format('MMM DD, YYYY')}
      </TableLink>
    ),
    field: 'report_date',
    headerName: 'Report Date',
    sortEnabled: false,
    width: 120,
  },
  {
    cellClass: 'security-cell',
    field: 'transaction_date',
    headerName: 'Trade Date',
    sortEnabled: false,
    valueFormatter: ({ value }) => dayjs(value).format('MMM DD, YYYY'),
    width: 120,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <ChamberBadge chamber={data.chamber ?? ''} />,
    field: 'chamber',
    headerName: 'Chamber',
    sortEnabled: false,
    width: 110,
  },
] as ColumnDef<GovernmentTradeRow>[];
